import { useCallback } from 'react';
import type { ReactElement } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { DecisionMakerRecommenderModalOptions } from './useDecisionMakerRecommenderModal';
import { useDecisionMakerRecommenderModal } from './useDecisionMakerRecommenderModal';

export type DecisionMakerRecommenderOptions = DecisionMakerRecommenderModalOptions & { onClose?: () => void };

export function useDecisionMakerRecommender(): [
	open: (options: DecisionMakerRecommenderOptions) => Promise<void>,
	modal: ReactElement,
] {
	const [openModal, modal] = useDecisionMakerRecommenderModal();
	const track = useTracking();

	const open = useCallback(
		async ({ onClose, ...options }: DecisionMakerRecommenderOptions) => {
			await openModal(options);
			void track('dm_modal_close', { context: options.trackingContext });
			onClose?.();
		},
		[openModal, track],
	);

	return [open, modal];
}
